module.exports = __webpack_public_path__ + "static/turquia-008.thumb-1b4654f83527c8b5b5aa9339b25a6c8c.jpg";